import { TrendingUp, ShieldCheck, Cpu, Target, Headphones, Leaf } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { useI18n } from "@/context/I18nContext";
import { SectionHeading } from "@/components/Section";
import { Link } from "react-router-dom";

export default function About() {
  const { settings } = useSettings();
  const { t } = useI18n();
  const values = [
    { icon: TrendingUp, k: "about.v1" },
    { icon: ShieldCheck, k: "about.v2" },
    { icon: Cpu, k: "about.v3" },
    { icon: Target, k: "about.v4" },
    { icon: Headphones, k: "about.v5" },
    { icon: Leaf, k: "about.v6" },
  ];
  return (
    <div className="section-lux grid-glow">
      <div className="container-lux">
        <SectionHeading label={t("about.label")} title={t("about.title")} />
        <div className="mt-8 max-w-3xl mx-auto text-center">
          <p className="text-slate-300 leading-relaxed text-lg">{settings.about_text || t("about.fallback")}</p>
        </div>
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {values.map((v, i) => (
            <div key={i} className="card-lux p-6 fade-up" style={{ animationDelay: `${i * 60}ms` }}>
              <v.icon className="text-amber-400 mb-4" size={26} />
              <h3 className="font-semibold text-white mb-2">{t(v.k + "t")}</h3>
              <p className="text-sm text-slate-400 leading-relaxed">{t(v.k + "d")}</p>
            </div>
          ))}
        </div>
        <div className="mt-14 text-center">
          <Link to="/contact" className="gold-btn">{t("about.cta")}</Link>
        </div>
      </div>
    </div>
  );
}
